export type ConfirmacaoV2Estilo = 'primaria' | 'perigo' | 'neutra';

export interface ConfirmacaoV2Acao {
  texto: string;
  valor: string;
  estilo?: ConfirmacaoV2Estilo;
}

/**
 * Estado de um diálogo de confirmação, no lugar do `window.confirm`.
 *
 * O componente hospedeiro guarda uma instância e renderiza o próprio
 * `<kendo-dialog>` — a marcação fica no template porque o estilo do diálogo
 * (z-index acima do drawer, botões do tema) depende do CSS daquele componente.
 *
 *   const escolha = await this.confirmacao.pergunte('Título', 'Mensagem', [
 *     { texto: 'Duplicar só aqui', valor: 'duplicar', estilo: 'neutra' },
 *     { texto: 'Editar em todos', valor: 'todos', estilo: 'primaria' }
 *   ]);
 */
export class ConfirmacaoV2 {
  aberta = false;
  titulo = '';
  mensagem = '';
  textoCancelar = 'Cancelar';
  acoes: ConfirmacaoV2Acao[] = [];

  private resolver: ((valor: string | null) => void) | null = null;

  /** Resolve com o `valor` da ação escolhida, ou `null` quando cancela/fecha. */
  pergunte(
    titulo: string,
    mensagem: string,
    acoes: ConfirmacaoV2Acao[],
    textoCancelar = 'Cancelar'
  ): Promise<string | null> {
    this.encerre(null);
    this.titulo = titulo;
    this.mensagem = mensagem;
    this.acoes = acoes;
    this.textoCancelar = textoCancelar;
    this.aberta = true;
    return new Promise<string | null>((resolve) => {
      this.resolver = resolve;
    });
  }

  confirme(
    titulo: string,
    mensagem: string,
    textoConfirmar = 'Confirmar',
    estilo: ConfirmacaoV2Estilo = 'perigo'
  ): Promise<boolean> {
    return this.pergunte(titulo, mensagem, [{ texto: textoConfirmar, valor: 'confirmar', estilo }])
      .then((valor) => valor === 'confirmar');
  }

  classeDaAcao(acao: ConfirmacaoV2Acao): string {
    if (acao.estilo === 'neutra') return 'pv2-ghost-btn';
    if (acao.estilo === 'primaria') return 'pv2-primary-btn';
    return 'pv2-primary-btn pv2-confirm-dialog__danger';
  }

  escolha(valor: string): void {
    this.encerre(valor);
  }

  cancele(): void {
    this.encerre(null);
  }

  private encerre(valor: string | null): void {
    const resolver = this.resolver;
    this.resolver = null;
    this.aberta = false;
    if (resolver) resolver(valor);
  }
}
